import { render, staticRenderFns } from "./safeguardClause.vue?vue&type=template&id=97c5d83c&scoped=true"
import script from "./safeguardClause.vue?vue&type=script&lang=js"
export * from "./safeguardClause.vue?vue&type=script&lang=js"
import style0 from "./safeguardClause.vue?vue&type=style&index=0&id=97c5d83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c5d83c",
  null
  
)

export default component.exports